// apps/web/src/data/astralThemes.ts
import type { AstralThemeDefinition, AstralThemeId } from "../types/astral";

export const ASTRAL_THEMES: Record<AstralThemeId, AstralThemeDefinition> = {
  sellflux: {
    id: "sellflux",
    name: "Sellflux (Cyber Funis)",
    bgCanvas: "#0b0f19",
    gridColor: "rgba(99, 102, 241, 0.08)",
    lineColor: "#6366f1",
    nodeRootBg: "#6366f1",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#818cf8",
    nodeLevel1Bg: "#151c2c",
    nodeLevel1Text: "#f9fafb",
    nodeLevel1Border: "rgba(99, 102, 241, 0.4)",
    nodeGeneralBg: "#111827",
    nodeGeneralText: "#e2e8f0",
    nodeGeneralBorder: "rgba(255, 255, 255, 0.1)",
    accentColors: ["#6366f1", "#10b981", "#0ea5e9", "#f59e0b", "#ec4899", "#8b5cf6"],
  },
  dark: {
    id: "dark",
    name: "Dark Mode (Obsidian)",
    bgCanvas: "#0b0e14",
    gridColor: "rgba(255, 255, 255, 0.04)",
    lineColor: "#334155",
    nodeRootBg: "#ef4444",
    nodeRootText: "#ffffff",
    nodeRootBorder: "rgba(239, 68, 68, 0.5)",
    nodeLevel1Bg: "#161c2b",
    nodeLevel1Text: "#f0f3f6",
    nodeLevel1Border: "rgba(255, 255, 255, 0.12)",
    nodeGeneralBg: "#111622",
    nodeGeneralText: "#cbd5e1",
    nodeGeneralBorder: "rgba(255, 255, 255, 0.08)",
    accentColors: ["#388bfd", "#2ea043", "#d29922", "#a371f7", "#f85149", "#39c5cf"],
  },
  meister: {
    id: "meister",
    name: "Meister (Clássico Claro)",
    bgCanvas: "#f8fafc",
    gridColor: "rgba(0, 0, 0, 0.05)",
    lineColor: "#94a3b8",
    nodeRootBg: "#2563eb",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#1d4ed8",
    nodeLevel1Bg: "#ffffff",
    nodeLevel1Text: "#0f172a",
    nodeLevel1Border: "#cbd5e1",
    nodeGeneralBg: "#ffffff",
    nodeGeneralText: "#334155",
    nodeGeneralBorder: "#e2e8f0",
    accentColors: ["#0284c7", "#16a34a", "#ca8a04", "#9333ea", "#dc2626", "#0d9488"],
  },
  ocean: {
    id: "ocean",
    name: "Ocean (Mar Profundo)",
    bgCanvas: "#071324",
    gridColor: "rgba(56, 189, 248, 0.05)",
    lineColor: "#0284c7",
    nodeRootBg: "#0284c7",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#38bdf8",
    nodeLevel1Bg: "#0b1e36",
    nodeLevel1Text: "#e0f2fe",
    nodeLevel1Border: "rgba(56, 189, 248, 0.3)",
    nodeGeneralBg: "#08192e",
    nodeGeneralText: "#bae6fd",
    nodeGeneralBorder: "rgba(56, 189, 248, 0.15)",
    accentColors: ["#38bdf8", "#06b6d4", "#2dd4bf", "#60a5fa", "#818cf8"],
  },
  sunset: {
    id: "sunset",
    name: "Sunset (Pôr do Sol)",
    bgCanvas: "#160b22",
    gridColor: "rgba(244, 63, 94, 0.05)",
    lineColor: "#e11d48",
    nodeRootBg: "#e11d48",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#fb7185",
    nodeLevel1Bg: "#26133b",
    nodeLevel1Text: "#ffe4e6",
    nodeLevel1Border: "rgba(244, 63, 94, 0.3)",
    nodeGeneralBg: "#1f0f30",
    nodeGeneralText: "#fecdd3",
    nodeGeneralBorder: "rgba(244, 63, 94, 0.15)",
    accentColors: ["#fb7185", "#f59e0b", "#ec4899", "#8b5cf6", "#fb923c"],
  },
  midnight: {
    id: "midnight",
    name: "Midnight (Cyber Neon)",
    bgCanvas: "#050508",
    gridColor: "rgba(168, 85, 247, 0.06)",
    lineColor: "#8b5cf6",
    nodeRootBg: "#8b5cf6",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#c084fc",
    nodeLevel1Bg: "#110e1f",
    nodeLevel1Text: "#f3e8ff",
    nodeLevel1Border: "rgba(168, 85, 247, 0.35)",
    nodeGeneralBg: "#0c0a17",
    nodeGeneralText: "#e9d5ff",
    nodeGeneralBorder: "rgba(168, 85, 247, 0.18)",
    accentColors: ["#a855f7", "#06b6d4", "#10b981", "#f43f5e", "#eab308"],
  },
  vintage: {
    id: "vintage",
    name: "Vintage (Nostalgia Pastel)",
    bgCanvas: "#181816",
    gridColor: "rgba(214, 211, 209, 0.04)",
    lineColor: "#78716c",
    nodeRootBg: "#d97706",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#f59e0b",
    nodeLevel1Bg: "#292524",
    nodeLevel1Text: "#f5f5f4",
    nodeLevel1Border: "#44403c",
    nodeGeneralBg: "#1c1917",
    nodeGeneralText: "#d6d3d1",
    nodeGeneralBorder: "#292524",
    accentColors: ["#ea580c", "#d97706", "#65a30d", "#0891b2", "#c026d3"],
  },
  bubbles: {
    id: "bubbles",
    name: "Bubbles (Cápsulas Coloridas)",
    bgCanvas: "#0e1320",
    gridColor: "rgba(255, 255, 255, 0.05)",
    lineColor: "#64748b",
    nodeRootBg: "#059669",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#10b981",
    nodeLevel1Bg: "#1e293b",
    nodeLevel1Text: "#f1f5f9",
    nodeLevel1Border: "rgba(16, 185, 129, 0.3)",
    nodeGeneralBg: "#151e2e",
    nodeGeneralText: "#e2e8f0",
    nodeGeneralBorder: "rgba(255, 255, 255, 0.1)",
    accentColors: ["#10b981", "#3b82f6", "#f59e0b", "#ec4899", "#8b5cf6"],
  },
  blackboard: {
    id: "blackboard",
    name: "Blackboard (Lousa Escura)",
    bgCanvas: "#0b1512",
    gridColor: "rgba(52, 211, 153, 0.04)",
    lineColor: "#10b981",
    nodeRootBg: "#047857",
    nodeRootText: "#ffffff",
    nodeRootBorder: "#34d399",
    nodeLevel1Bg: "#0f231d",
    nodeLevel1Text: "#d1fae5",
    nodeLevel1Border: "rgba(52, 211, 153, 0.3)",
    nodeGeneralBg: "#0a1914",
    nodeGeneralText: "#a7f3d0",
    nodeGeneralBorder: "rgba(52, 211, 153, 0.15)",
    accentColors: ["#34d399", "#6ee7b7", "#a7f3d0", "#fde047", "#67e8f9"],
  },
};
